import { isLocalDomain } from '../../utils/aem-utils';
import { filter } from '../../utils/array-utils';
import { getLocation, getParamFromUrl } from '../../utils/build-urls';
import { changeUrlNoHistory } from '../../utils/change-url';
import { hideElement, isNodeOnFocus, scrollToElement } from '../../utils/dom-utils';
import { trackComscore } from '../../utils/analytics';
import { satelliteTracker } from '../../services/tracking/satellite-tracking-service';
import { dynamicTrackingOnNewsUCanUse } from '../../services/tracking/parsely-tracking-service';

/** *******
 * CONSTANTS **
 *********/
const TOP_THRESHOLD = 400;
export const RESPONSIVE_OFFSET = {
  mobile: 70,
  desktop: 135,
};
const BASE_LOCALHOST = 'https://localhost.sky.it:4200';
const QUERY_PARAM_NAME = 'card';
const SMOOTH_SCROLL_DELAY = 800;
const TRACKED_BY_COMSCORE = 'tracked';
const GALLERY_TRACKING_EVENT = 'change_gallery';
const OUT_OF_EDGE_INDEX = -1;
let currentCardIndex = OUT_OF_EDGE_INDEX;

const currentLocation = isLocalDomain() ? BASE_LOCALHOST : getLocation().withPathName;
const isEdgeCard = ($cards, cardIndex) => cardIndex === 0 || cardIndex === $cards.length - 1;
const updateUrl = (cardId) => {
  if (cardId) {
    changeUrlNoHistory(`${currentLocation}?${QUERY_PARAM_NAME}=${cardId}`);
    return;
  }
  changeUrlNoHistory(currentLocation);
};
const updateCurrentCardIndex = (index) => {
  currentCardIndex = index;
};
const getCardIdFromUrl = () => getParamFromUrl(QUERY_PARAM_NAME);
const trackAnalytics = ({ $card, cardId }) => {
  const isCardTrackedByComscore = $card.dataset.state === TRACKED_BY_COMSCORE;
  if (!isCardTrackedByComscore) {
    trackComscore();
    $card.dataset.state = TRACKED_BY_COMSCORE;
  }
  satelliteTracker.trackInWeb(GALLERY_TRACKING_EVENT, { hash: cardId });
  dynamicTrackingOnNewsUCanUse(cardId);
};

/** *********
 * HANDLERS *
 ************/
const handleHideReadMoreContent = ($readMoreCard) => {
  const $inlineCards = $readMoreCard.querySelectorAll('.c-inline-card');
  $inlineCards.forEach(($inlineCard) => {
    const locationWithPathname = getLocation().withPathName;
    const href = $inlineCard.getAttribute('href');
    if (locationWithPathname === href) {
      hideElement($inlineCard);
    }
  });
};

const handleComponentOnFocus = (() => {
  let isComponentOnFocus = false;

  return ({ $newsYouCanUse }) => {
    if (!isComponentOnFocus && isNodeOnFocus($newsYouCanUse, TOP_THRESHOLD)) {
      isComponentOnFocus = true;
    }
    if (isComponentOnFocus && !isNodeOnFocus($newsYouCanUse, TOP_THRESHOLD)) {
      updateCurrentCardIndex(OUT_OF_EDGE_INDEX);
      updateUrl();
      isComponentOnFocus = false;
    }
  };
})();

const handleScrolling = ({ $newsYouCanUse, $cards, $heroMediaWrapper, $playerHero, $readMoreCard }) => {
  // Check possible new card on focus
  for (let index = 0; index < $cards.length; index++) {
    const $card = $cards[index];
    if (isNodeOnFocus($card, TOP_THRESHOLD) && currentCardIndex !== index) {
      // A NEW card is on focus!
      trackAnalytics({ $card, cardId: $card.id, $readMoreCard });
      updateCurrentCardIndex(index);
      updateUrl($card.id);
      break;
    }
  }

  // The whole component is/is not on focus
  if (isEdgeCard($cards, currentCardIndex)) {
    handleComponentOnFocus({
      $newsYouCanUse,
      $heroMediaWrapper,
      $playerHero,
    });
  }
};

const handleCardIdFromUrl = ($cards, cardIdQueryParam) => {
  const $targetElement = filter(($card) => $card.id === cardIdQueryParam)($cards)[0];
  if (!$targetElement) {
    return;
  }
  scrollToElement({ $element: $targetElement, responsiveOffset: RESPONSIVE_OFFSET, delay: SMOOTH_SCROLL_DELAY });
};

export default {
  getCardIdFromUrl,
  handleHideReadMoreContent,
  handleScrolling,
  handleCardIdFromUrl,
};
